import { Controller } from "@hotwired/stimulus";

// Handles configuration/preview tab switching on small screens.
// On desktop (>= 900px container), both panels are always visible side-by-side.
// On mobile, only the active tab's panel is shown.
export default class extends Controller {
  static targets = ["tab", "panel"];

  switch(event) {
    const activeTab = event.currentTarget.dataset.tab;

    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tab === activeTab;
      tab.classList.toggle("text-brand-500", isActive);
      tab.classList.toggle("font-semibold", isActive);
      tab.classList.toggle("border-brand-500", isActive);
      tab.classList.toggle("border-transparent", !isActive);
      tab.classList.toggle("text-gray-500", !isActive);
      tab.classList.toggle("font-normal", !isActive);
    });

    this.panelTargets.forEach((panel) => {
      const isActive = panel.dataset.panel === activeTab;
      // Use a data attribute to track mobile-hidden state so it doesn't
      // conflict with the responsive @[900px]:block class from Tailwind.
      // The CSS below handles hiding on mobile only.
      panel.classList.toggle("checkout-tab-hidden", !isActive);
    });
  }
}
